import { Injectable } from '@angular/core';
import { REGISTER } from 'app/model/register.model';
import { SharedPdfService } from 'app/services/shared/shared-pdf.service';

@Injectable()
export class BUSINESSGROUPRPDFService {
  constructor(private sharedPdfService: SharedPdfService) {}

  web() {
    // console.log(window.location.href.indexOf('.co.nz'));
    return window.location.href.indexOf('.co.nz');
    // return 1;
  }

  generateBusinessContacts(pdfOBJ: REGISTER) {

    // console.log('check ' , pdfOBJ.businessGroup.in_required_credit, pdfOBJ.businessGroup.in_required_credit ===
    // '10 Day (>$10k per month)');
    return {
      style: 'tableExample',

      table: {
        widths: ['20%', '25%', '30%', '25%'],
        body: [
          [
            {
              text: 'Position:',
              style: 'questions'
            },
            {
              style: 'questions',
              text: 'Name:'
            },
            {
              text: 'Email:',
              style: 'questions'
            },
            {
              text: 'Phone:',
              style: 'questions'
            }
          ],

          [
            {
              text: 'Sales Manager:',
              style: 'questions'
            },
            {
              italics: true,
              text: '' + pdfOBJ.businesscontacts.in_so_manager_name
            },
            {
              text: '' + pdfOBJ.businesscontacts.in_so_manager_email,
              italics: true
            },
            {
              text:
                pdfOBJ.businesscontacts.in_so_manager_phonecode +
                '' +
                pdfOBJ.businesscontacts.in_so_manager_phone,
              italics: true
            }
          ],

          [
            {
              text: 'Purchasing Officer:',
              style: 'questions'
            },
            {
              italics: true,
              text: '' + pdfOBJ.businesscontacts.in_po_manager_name
            },
            {
              text: '' + pdfOBJ.businesscontacts.in_po_manager_email,
              italics: true
            },
            {
              text:
                pdfOBJ.businesscontacts.in_po_manager_phonecode +
                '' +
                pdfOBJ.businesscontacts.in_po_manager_phone,
              italics: true
            }
          ],

          [
            {
              text: 'Accounts Payable:',
              style: 'questions'
            },
            {
              italics: true,
              text: '' + pdfOBJ.businesscontacts.in_ap_manager_name
            },
            {
              text: '' + pdfOBJ.businesscontacts.in_ap_manager_email,
              italics: true
            },
            {
              text:
                pdfOBJ.businesscontacts.in_ap_manager_phonecode +
                '' +
                pdfOBJ.businesscontacts.in_ap_manager_phone,
              italics: true
            }
          ]
        ]
      }
    };
  }
  generateBusinessRelate(pdfOBJ: REGISTER) {
    // console.log('check value: ',pdfOBJ.guaranteeGroup, pdfOBJ.deliverMethodArray);
    return {
      style: 'tableExample',

      table: {
        widths: ['50%', '25%', '25%'],

        body: [
          [
            {
              text: 'Organisation Type:',
              style: 'questions'
            },
            {
              colSpan: 2,
              style: 'questions',
              text: 'Postal Address Street Number:'
            },
            ''
          ],
          [
            { text: ' ' + pdfOBJ.businessGroup.in_org_type, italics: true },
            {
              colSpan: 2,
              text: ' ' + pdfOBJ.businessGroup.in_company_address1,
              italics: true
            },
            ''
          ],

          [
            { style: 'questions', text: 'Company Name:' },
            { colSpan: 2, style: 'questions', text: 'Street:' },
            ''
          ],
          [
            {
              text: ' ' + pdfOBJ.businessGroup.in_customer_name,
              italics: true
            },
            {
              colSpan: 2,
              text: ' ' + pdfOBJ.businessGroup.in_company_street,
              italics: true
            },
            ''
          ],

          [
            { text: 'Trading Entity Name:', style: 'questions' },
            { text: 'Company Suburb:', colSpan: 2, style: 'questions' },
            ''
          ],
          [
            { text: ' ' + pdfOBJ.businessGroup.in_entity_name, italics: true },
            {
              text: ' ' + pdfOBJ.businessGroup.in_company_suburb,
              italics: true,
              colSpan: 2
            },
            ''
          ],

          [
            { text: 'Name Of Trust:', style: 'questions' },
            { text: 'Country:', style: 'questions', colSpan: 2 },
            ''
          ],

          [
            { text: ' ' + pdfOBJ.businessGroup.in_trust_name, italics: true },
            {
              text:
                ' ' +
                (typeof pdfOBJ.businessGroup.in_company_country == 'undefined'
                  ? ' '
                  : pdfOBJ.businessGroup.in_company_country),
              colSpan: 2,
              italics: true
            },
            ''
          ],

          [
            { text: this.web() > 0 ? 'NZBN' : 'ABN:', style: 'questions' },
            { text: 'Postcode:', style: 'questions', colSpan: 2 },
            ''
          ],
          [
            { text: ' ' + pdfOBJ.businessGroup.in_ABN, italics: true },
            {
              text: ' ' + pdfOBJ.businessGroup.in_company_postcode,
              italics: true,
              colSpan: 2
            },
            ''
          ],
          [
            { text: this.web() > 0 ? 'NZCN' : 'ACN:', style: 'questions' },
            {
              text: 'Name Of Parent And Related Companies:',
              colSpan: 2,
              style: 'questions'
            },

            ''
          ],
          [
            { text: ' ' + pdfOBJ.businessGroup.in_ACN, italics: true },

            {
              text: ' ' + pdfOBJ.businessGroup.in_parent_company,
              italics: true,
              colSpan: 2
            },

            ''
          ],

          [
            { text: 'Date Your Business Started:', style: 'questions' },

            {
              text:
                'Trading/Delivery Address (If Different From Postal Address):',
              colSpan: 2,
              style: 'questions'
            },

            {
              text: ''
            }
          ],
          [
            {
              text:
                ' ' +
                this.sharedPdfService.dateformat(
                  pdfOBJ.businessGroup.in_date_business_started
                ),
              italics: true
            },
            {
              text: ' ' + pdfOBJ.businessGroup.in_delivery_address1,
              italics: true,
              colSpan: 2
            },

            ''
          ],
          [
            { text: 'Date You Purchased The Business:', style: 'questions' },

            {
              text:
                'Trading/Delivery address 2(If Different From Postal Address:',
              colSpan: 2,
              style: 'questions'
            },

            ''
          ],
          [
            {
              text:
                ' ' +
                this.sharedPdfService.dateformat(
                  pdfOBJ.businessGroup.in_date_business_purchased
                ),
              italics: true
            },
            {
              text:
                ' ' +
                (pdfOBJ.businessGroup.in_delivery_address2.length > 0
                  ? pdfOBJ.businessGroup.in_delivery_address2 + ','
                  : '') +
                ' ' +
                pdfOBJ.businessGroup.in_delivery_suburb +
                ' ' +
                pdfOBJ.businessGroup.in_delivery_postcode +
                ' ' +
                pdfOBJ.businessGroup.in_delivery_country,
              italics: true,
              colSpan: 2
            },

            ''
          ],
          [
            {
              text: 'Name And Suburb Of Business Bank:',

              style: 'questions'
            },
            {
              text: 'Tenancy:',
              colSpan: 2,
              style: 'questions'
            },
            ''
          ],
          [
            {
              text: ' ' + pdfOBJ.businessGroup.in_bank_address1,
              italics: true
            },
            {
              text: ' ' + pdfOBJ.businessGroup.in_tenancy,
              italics: true,
              colSpan: 2
            },
            ''
          ],

          [
            {
              text: 'Swift Address:',
              style: 'questions'
            },
            {
              text: 'How Long At Current Address:',
              colSpan: 2,
              style: 'questions'
            },
            ''
          ],
          [
            {
              text: ' ' + pdfOBJ.businessGroup.in_swift_address,
              italics: true
            },
            {
              text: ' ' + pdfOBJ.businessGroup.in_time_at_address,
              colSpan: 2,
              italics: true
            },
            ''
          ],

          [
            {
              text: 'Account Name:',
              style: 'questions'
            },
            {
              text: 'E-mail (For All Correspondence):',
              colSpan: 2,
              style: 'questions'
            },
            ''
          ],
          [
            {
              text: ' ' + pdfOBJ.businessGroup.in_bank_account_name,
              italics: true
            },
            {
              text: ' ' + pdfOBJ.businessGroup.in_email,
              italics: true,
              colSpan: 2
            },
            ''
          ],
          [
            {
              text: 'BSB:',
              style: 'questions'
            },
            {
              text: 'Phone:',
              colSpan: 2,
              style: 'questions'
            },

            ''
          ],
          [
            {
              text: ' ' + pdfOBJ.businessGroup.in_bsb,
              italics: true
            },
            {
              text:
                ' ' +
                pdfOBJ.businessGroup.in_phonecode +
                ' ' +
                pdfOBJ.businessGroup.in_phone,
              colSpan: 2,
              italics: true
            },

            ''
          ],

          [
            {
              text: 'Account Number:',
              style: 'questions'
            },
            {
              text: 'Company Website:',
              colSpan: 2,
              style: 'questions'
            },

            ''
          ],
          [
            {
              text: ' ' + pdfOBJ.businessGroup.in_account_number,
              italics: true
            },
            {
              text: ' ' + pdfOBJ.businessGroup.in_company_website_url,
              colSpan: 2,
              italics: true
            },

            ''
          ],

          [
            {
              text: 'Date Of Incorporation:',
              style: 'questions'
            },

            {
              text: 'Online Administrator/Contact:',
              colSpan: 2,
              style: 'questions'
            },

            ''
          ],
          [
            {
              text:
                ' ' +
                this.sharedPdfService.dateformat(
                  pdfOBJ.businessGroup.in_incorporation_date
                ),
              italics: true
            },

            {
              text: ' ' + pdfOBJ.businessGroup.in_online_contact,
              italics: true,
              colSpan: 2
            },

            ''
          ],
          [
            {
              text:
                this.web() > 0
                  ? 'Estimated Monthly Purchases'
                  : 'Place Of Incorporation:',
              style: 'questions'
            },

            {
              text: 'Administrator Email:',
              colSpan: 2,
              style: 'questions'
            },

            ''
          ],
          [
            {
              text:
                ' ' +
                (this.web() > 0
                  ? pdfOBJ.businessGroup.in_estimated_monthly_purch.length > 0
                    ? this.sharedPdfService.commaPipe(
                        pdfOBJ.businessGroup.in_estimated_monthly_purch
                      )
                    : ''
                  : pdfOBJ.businessGroup.in_incorporation_place),
              italics: true
            },

            {
              text: ' ' + pdfOBJ.businessGroup.in_admin_email,
              italics: true,
              colSpan: 2
            },

            ''
          ],

          [
            { text: 'Credit Account Requested:', style: 'questions' },
            {
              text: 'Requested User Password:',
              colSpan: 2,
              style: 'questions'
            },
            // {
            //   text: "Requesting credit limit required",
            //   colSpan: 2,
            //   style: "questions"
            // },
            ''
          ],
          [
            {
              // tslint:disable-next-line:max-line-length
              text:
                this.web() > 0
                  ? ' ' + (pdfOBJ.businessGroup.in_required_credit ===
                    '10 Day (>$10k per month)'
                    ? '20th of Month'
                    : pdfOBJ.businessGroup.in_required_credit)
                  : ' ' + pdfOBJ.businessGroup.in_required_credit,
              italics: true
            },
            {
              text: ' ' + pdfOBJ.businessGroup.in_password,
              italics: true,
              colSpan: 2
            },
            ''
          ],

          [
            {
              pageBreak: 'before',
              text: 'Requesting credit limit required:',
              // colSpan: 2,
              style: 'questions'
            },
            {
              pageBreak: 'before',
              text: 'Delivery Instructions:',
              colSpan: 2,
              style: 'questions'
            },
            ''
          ],
          [
            {
              text:
                ' ' +
                (pdfOBJ.businessGroup.in_RequestLimitCredit.length > 0
                  ? this.sharedPdfService.commaPipe(
                      pdfOBJ.businessGroup.in_RequestLimitCredit
                    )
                  : ''),
              italics: true
              // colSpan: 2
            },
            {
              text:
                ' ' +
                (pdfOBJ.businessGroup.in_part_ship == 'No Part Ship'
                  ? ' '
                  : 'Part Ship'),
              italics: true,
              colSpan: 2
            },
            ''
          ]

          // [
          //   {
          //     // text: "Compnay Address Details 2:"
          //     text: 'Delivery Country:',
          //     style: 'questions'
          //   },
          //   {
          //     text: 'Delivery Suburb:',
          //     // colSpan: 2,

          //     style: 'questions'
          //   },
          //   {
          //     text: 'Delivery Postcode:',
          //     style: 'questions'
          //   }
          // ],
          // [
          //   {
          //     text: ' ' + pdfOBJ.businessGroup.in_delivery_country,
          //     italics: true
          //   },
          //   {
          //     text: ' ' + pdfOBJ.businessGroup.in_delivery_suburb,
          //     italics: true
          //   },
          //   {
          //     text: ' ' + pdfOBJ.businessGroup.in_delivery_postcode,
          //     italics: true
          //   }
          // ]
        ]
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/pdf/businessgrouppdf.generation.ts